module.exports = __webpack_public_path__ + "img/SpinText.8ae61fd9.svg";